import { useSelector } from '@grandvisionhq/state';
import { getShippingDetails } from '../../../../../StepShipping/selectors.js';
import { useCheckoutSettings } from '../../../../../context/CheckoutSettings/context.js';

const useRequiredContactFields = ()=>{
    var ref;
    const shippingDetails = useSelector(getShippingDetails);
    const { features  } = useCheckoutSettings();
    if (!(shippingDetails === null || shippingDetails === void 0 ? void 0 : (ref = shippingDetails.expressCheckout) === null || ref === void 0 ? void 0 : ref.isEnabled)) {
        return [];
    }
    let requiredContactFields = [
        'email',
        'postalAddress',
        'name',
        'phone', 
    ];
    // Phone number is required by default. Just like in the regular checkout.
    if (typeof (features === null || features === void 0 ? void 0 : features.phoneNumberRequired) === 'boolean' && !(features === null || features === void 0 ? void 0 : features.phoneNumberRequired)) {
        requiredContactFields = requiredContactFields.filter((formField)=>formField !== 'phone'
        );
    }
    return requiredContactFields;
};

export { useRequiredContactFields };
//# sourceMappingURL=use-required-contact-fields.js.map
